import React from "react";

const TypingMessage = () => {
    return <div className="message-box">
        <div className="message typing">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
        </div>
    </div>
}

export default TypingMessage;
